export enum ExpenseStatus {
    New = 0,
    Approval,
    Accepted,
    Rejected
}